import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";
import Home from "@/views/Home.vue";
import NotFoundPage from "@/views/NotFoundPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    // Only routes labelled as public do not require logging in
    meta: {
      public: true
    }
  },
  {
    path: "/about",
    name: "about",
    meta: {
      public: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/account",
    name: "account",
    component: () =>
      import(/* webpackChunkName: "account" */ "../views/UserAccount.vue")
  },
  {
    path: "/email-confirm/:verificationKey",
    name: "email-confirm",
    props: true,
    meta: {
      public: true
    },
    component: () =>
      import(
        /* webpackChunkName: "email-confirm" */ "../views/EmailConfirm.vue"
      )
  },
  {
    path: "/password-reset/:uid?/:token?/",
    name: "password-reset",
    props: true,
    meta: {
      public: true
    },
    component: () =>
      import(
        /* webpackChunkName: "password-reset" */ "../views/PasswordReset.vue"
      )
  },
  {
    path: "/catalog",
    name: "catalog",
    component: () =>
      import(/* webpackChunkName: "catalog" */ "../views/Catalog.vue")
  },
  {
    path: "/collection",
    name: "collection",
    component: () =>
      import(/* webpackChunkName: "collection" */ "../views/Collection.vue")
  },
  {
    path: "/editor",
    name: "editor",
    component: () =>
      import(/* webpackChunkName: "editor" */ "../views/FretboardEditor.vue")
  },
  {
    path: "/games",
    name: "games",
    meta: {
      public: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "games" */ "../views/GamesPage.vue")
  },
  {
    path: "/courses",
    name: "courses",
    component: () =>
      import(/* webpackChunkName: "courses" */ "../views/CourseListPage.vue")
  },
  {
    path: "/course/:id",
    name: "course",
    props: true,
    component: () =>
      import(/* webpackChunkName: "course" */ "../views/CoursePage.vue")
  },
  {
    path: "/lessons",
    name: "lessons",
    component: () =>
      import(/* webpackChunkName: "lessons" */ "../views/LessonListPage.vue")
  },
  {
    path: "/lesson/:id/",
    name: "lesson",
    props: true,
    component: () =>
      import(/* webpackChunkName: "lesson" */ "../views/LessonPage.vue")
  },
  {
    // use for manually testing new components
    path: "/test",
    name: "test",
    meta: {
      public: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      // import the tested component here
      import(/* webpackChunkName: "test" */ "../views/DemoScores.vue")
  },
  {
    path: "*",
    meta: {
      public: true
    },
    component: NotFoundPage
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.API_BASE_URL,
  routes
});

export const processLoggedInState = (to, next) => {
  const isLoggedIn = store.getters["accounts/isLoggedIn"];
  const isPrivate = to.matched.some(record => !record.meta.public);
  const isLoginPage = to.name == "home";

  if (isPrivate && !isLoggedIn) {
    // remember route to go once logged in:
    store.dispatch("routing/setNextRoute", to);
    next({ name: "home" });
  } else if (isLoggedIn && isLoginPage) {
    next({ name: "catalog" });
  } else {
    next();
  }
};

router.beforeEach((to, from, next) => processLoggedInState(to, next));

export default router;
